<template>
  <div class="header">
    <div class="logo">
      <div class="slogo">
        <img src="../../assets/index/ztLOGO.png" />
      </div>
    </div>
    <ul class="nav">
      <li class="nav_title active">
        <router-link to="/index" tag="span">首 页</router-link>
      </li>
      <li class="nav_title">
        <router-link tag="span" to="/enterZT">走进珠涂</router-link>
        <div class="tnav">
          <div class="tnav_li" @click="goRouter('/enterZT')">公司简介</div>
          <div class="tnav_li" @click="goRouter('/enterZT/event')">大事记</div>
          <div class="tnav_li" @click="goRouter('/enterZT/research')">
            研发实力
          </div>
          <div class="tnav_li" @click="goRouter('/enterZT/network')">
            销售网点
          </div>
          <div class="tnav_li" @click="goRouter('/enterZT/project')">
            工程案例
          </div>
          <div class="tnav_li" @click="goRouter('/enterZT/jobs')">人才招聘</div>
        </div>
      </li>
      <li class="nav_title">
        <router-link tag="span" to="/materials">万力新材料</router-link>
      </li>
      <li class="nav_title">
        <router-link tag="span" to="/houses">品牌家族</router-link>
        <div class="tnav">
          <div class="tnav_li" @click="goRouter('/houses')">电视塔牌</div>
          <div class="tnav_li" @click="goRouter('/houses/houses2')">青竹牌</div>
          <div class="tnav_li" @click="goRouter('/houses/houses3')">青松牌</div>
          <div class="tnav_li" @click="goRouter('/houses/houses4/1')">
            南方牌
          </div>
          <div class="tnav_li" @click="goRouter('/houses/houses4/0')">
            东风施能
          </div>
        </div>
      </li>

      <li class="nav_title">
        <router-link tag="span" to="/product">产品中心</router-link>
      </li>
      <li class="nav_title">
        <router-link tag="span" to="/technology">服务支持</router-link>
      </li>
      <li class="nav_title">
        <router-link tag="span" to="/news">新闻动态</router-link>
      </li>
      <li class="nav_title">
        <router-link tag="span" to="/concact">联系我们</router-link>
      </li>
    </ul>
    <div class="search">
      <input type="text" v-model="searchV" />
      <img src="../../assets/index/search.png" @click="search" />
    </div>
    <!-- <div class="hphone">
          <img src="../../assets/index/call.png">
          <span>0756-6327128</span>
        </div> -->
  </div>
</template>

<script>
export default {
  name: "zhead",
  props: {
    msg: String
  },
  data() {
    return {
      searchV: ""
    };
  },
  mounted() {
    console.log("2222222222===", this.$router);
    // this.$router.push({
    //   path:'/enterZT'
    // })
  },

  methods: {
    search() {
      this.$router.push({ path: "/product", query: { searchV: this.searchV } });
    },
    goRouter(url) {
      console.log("================2222");
      this.$router.push({ path: url });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
  width: 1200px;
  height: 100px;
  margin: 0 auto;
  /* padding-left: 22px; */
  box-sizing: border-box;
}

.logo {
  float: left;

  .slogo {
    // width: 130px;
    height: 45px;
    display: inline-block;
    margin-top: 26px;

    img {
      height: 100%;
      object-fit: contain;
    }
  }
}

.nav {
  width: 730px;
  float: left;
  margin-left: 10px;

  li {
    cursor: pointer;
    width: 12.5%;
    float: left;
    line-height: 100px;
    font-size: 18px;
    color: #0a308f;
    position: relative;
    padding: 0 1px 0 0px;
    box-sizing: border-box;
    &:hover span {
      width: 100%;
      height: 40px;
      background-color: #0a308f;
      color: #fff;
      display: inline-block;
      line-height: 40px;
      box-sizing: border-box;
    }
    &:hover .tnav {
      display: block;
    }
    .tnav {
      position: absolute;
      top: 70px;
      width: 100%;
      display: none;
      background-color: #eeeeee;
      z-index: 2000;
      /* border-top: solid 1px #e5e5e5; */
      .tnav_li {
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        color: #333333;
        /* font-weight:300; */
        border-bottom: solid 1px #e5e5e5;

        &:hover {
          background-color: #0a308f;
          color: #fff;
          border-bottom: none;
        }
      }
    }
  }
}

.search {
  width: 160px;
  height: 34px;
  border-radius: 20px;
  border: solid 1px #436cd1;
  position: relative;
  float: left;
  margin-top: 32px;
  margin-left: 10px;
}

.search input {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  padding-left: 21px;
  padding-right: 30px;
  box-sizing: border-box;
  background: none;
}

.search img {
  position: absolute;
  top: 8px;
  right: 13px;
  width: 21px;
  cursor: pointer;
}

.hphone {
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 100px;
  letter-spacing: 0.1042vw;
  color: #0a308f;
}

.hphone img {
  width: 21px;
  margin-right: 9px;
}

.router-link-active {
  width: 100%;
  height: 40px;
  background-color: #0a308f;
  color: #fff;
  display: inline-block;
  line-height: 40px;
}
</style>
